
export const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';
export const DEFAULT_FONT = 'Times new Roman';
